export default __webpack_public_path__ + "static/media/r5.ccfd8f09.jpg";